import React from 'react';

import { Counter } from '../../../../../../../components/Counter/Counter';
import { Heading } from '../../../../../../../components/Heading/Heading';
import { Text } from '../../../../../../../components/Text/Text';
import { abbreviateNumber } from '../../../../../../../helpers/numbers/abbreviateNumber';

interface IProps {
  totalCount?: number;
  isTooZoomedInAndNotPro?: boolean;
}

export const CatchesViewHeader = ({ totalCount, isTooZoomedInAndNotPro = false }: IProps) => {
  return (
    <div>
      <div className="bg-lake-fog flex items-center">
        <Heading variant="sm" className="pr-2">
          Catches
        </Heading>
        {totalCount !== undefined && <Counter variant="sm">{abbreviateNumber(totalCount)}</Counter>}
      </div>
      <Text variant="sm">
        {isTooZoomedInAndNotPro
          ? 'Zoom out to see catches in the map area'
          : 'Add filters and reposition the map to explore more catches'}
      </Text>
    </div>
  );
};
